import { ClipboardList, Ticket, Wallet, Users, HandCoins, ShoppingBag, FileSignature, Gift, CalendarCheck } from "lucide-react";

export const PRODUCT_PAGES = {
  "hojas-de-inscripcion": {
    icon: ClipboardList,
    eyebrow: "Hojas de inscripción",
    title: "Coordina eventos y voluntarios en minutos.",
    subtitle: "Cupos por espacio, sin duplicados y sin app para tus invitados. Un solo link y todos se apuntan.",
    hero_img: "https://images.unsplash.com/photo-1529832588601-c01e066263a8?w=1200&q=75&fm=jpg",
    features: [
      { title: "Cupos por espacio", desc: "Define cuántas personas caben en cada rol o platillo. La app cierra los cupos automáticamente." },
      { title: "Comparte con un link", desc: "WhatsApp, correo o donde sea. Los invitados abren, eligen su lugar y listo." },
      { title: "Sin cuenta para invitados", desc: "Cero fricción para la gente que se apunta. Solo su nombre." },
      { title: "Editable después", desc: "Añade espacios, cambia horarios o modifica descripciones cuando quieras." },
    ],
    use_cases: ["Potluck y fiestas", "Kermés escolar", "Voluntariado", "Ministerios de iglesia"],
    cta_route: "/registro",
  },
  "boletos": {
    icon: Ticket,
    eyebrow: "Boletos con QR",
    title: "Vende boletos y haz check-in desde tu celular.",
    subtitle: "Tipos de boleto (General, VIP), cupo por tipo y códigos QR únicos para agilizar la entrada.",
    hero_img: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=1200&q=75&fm=jpg",
    features: [
      { title: "Tipos de boleto", desc: "General, VIP, Estudiante — con precios y cupos independientes." },
      { title: "QR único por asiento", desc: "Cada boleto trae un QR único. El asistente lo muestra y listo." },
      { title: "Check-in rápido", desc: "Marca la entrada desde tu panel. Nadie se cuela, ningún duplicado." },
      { title: "Pago manual o digital", desc: "Cobra en efectivo, transferencia o (próximamente) Stripe / Mercado Pago." },
    ],
    use_cases: ["Conciertos", "Retiros y talleres", "Rifas y kermés", "Eventos con cupo"],
    cta_route: "/registro",
  },
  "cuotas": {
    icon: Wallet,
    eyebrow: "Cuotas y cobros",
    title: "Lleva la lista de quién ya pagó.",
    subtitle: "Cuotas del salón, membresías o inscripciones — con fecha límite, notas de pago y pagos parciales.",
    hero_img: "https://images.unsplash.com/photo-1588075592405-d3d4f0846961?w=1200&q=75&fm=jpg",
    features: [
      { title: "Monto y moneda", desc: "MXN, USD, COP, ARS y más. Fecha límite opcional." },
      { title: "Pagos parciales", desc: "Permite que la gente abone poco a poco si tu cuota es grande." },
      { title: "Marca como pagado", desc: "Registro manual con un click. Total recaudado en vivo." },
      { title: "Notas de pago", desc: "Comparte tu CLABE o instrucciones directo en el evento." },
    ],
    use_cases: ["Cuota mensual del salón", "Inscripción escolar", "Membresía anual", "Cuotas deportivas"],
    cta_route: "/registro",
  },
  "recaudacion-en-equipo": {
    icon: Users,
    eyebrow: "Recaudación en equipo",
    title: "Que cada participante empuje la meta.",
    subtitle: "Compartan un mismo objetivo y cada quien invita a sus contactos. Todo suma a la meta común.",
    hero_img: "https://images.unsplash.com/photo-1758599667718-684569efe224?w=1200&q=75&fm=jpg",
    features: [
      { title: "Meta común", desc: "Todos aportan al mismo objetivo con barra de progreso pública." },
      { title: "Aportaciones anónimas", desc: "Quien quiera puede donar de forma anónima." },
      { title: "Mensajes de apoyo", desc: "Cada aportación puede llevar un mensaje corto." },
      { title: "Comparte por link", desc: "Cada quien reenvía el mismo link para llegar a la meta más rápido." },
    ],
    use_cases: ["Causa comunitaria", "Escuela rural", "Emergencia familiar", "Proyecto de ONG"],
    cta_route: "/registro",
  },
  "donaciones": {
    icon: HandCoins,
    eyebrow: "Donaciones",
    title: "Recibe donaciones para tu causa.",
    subtitle: "Meta pública, barra de progreso en vivo y opción de donar anónimamente.",
    hero_img: "https://images.unsplash.com/photo-1758599667718-684569efe224?w=1200&q=75&fm=jpg",
    features: [
      { title: "Meta con progreso", desc: "La comunidad ve cuánto llevas y cuánto falta." },
      { title: "Anónimo opcional", desc: "Cada donador decide si aparece o no con nombre." },
      { title: "Registro manual", desc: "Marca las donaciones recibidas por transferencia o efectivo." },
      { title: "Descarga la lista", desc: "Exporta el registro para tu contabilidad (próximamente)." },
    ],
    use_cases: ["Damnificados", "Escuelas", "ONGs", "Iglesias"],
    cta_route: "/registro",
  },
  "tienda-en-linea": {
    icon: ShoppingBag,
    eyebrow: "Tienda en línea",
    title: "Vende mercancía sin abrir otra tienda.",
    subtitle: "Playeras, tazas, snacks o lo que sea — con stock, moneda y carrito integrados.",
    hero_img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=1200&q=75&fm=jpg",
    features: [
      { title: "Múltiples productos", desc: "Cada uno con precio, moneda, stock y descripción." },
      { title: "Carrito automático", desc: "Los clientes suman productos y el total se calcula al vuelo." },
      { title: "Stock ilimitado o cerrado", desc: "Cierra el cupo cuando se agote o deja stock abierto." },
      { title: "Pago manual", desc: "Coordina la entrega y confirma el pago desde tu panel." },
    ],
    use_cases: ["Playeras del equipo", "Merch de banda", "Snacks para kermés", "Rifas con premios"],
    cta_route: "/registro",
  },
  "formularios-y-consentimientos": {
    icon: FileSignature,
    eyebrow: "Formularios y consentimientos",
    title: "Recolecta datos y firmas digitales.",
    subtitle: "Crea formularios con los campos que necesites y solicita firma cuando aplique.",
    hero_img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=75&fm=jpg",
    features: [
      { title: "Campos personalizables", desc: "Texto, correo, teléfono, selección, casilla, fecha, número — el que necesites." },
      { title: "Requerido u opcional", desc: "Marca cada campo como quieras. Sin campos duplicados." },
      { title: "Firma digital", desc: "Consentimientos con firma escrita y opción de firma de padre/tutor." },
      { title: "Ver respuestas", desc: "Tabla completa desde tu panel para revisar cada envío." },
    ],
    use_cases: ["Registro a evento", "Encuestas", "Carta responsiva", "Excursión escolar"],
    cta_route: "/registro",
  },
  "regalos-grupales": {
    icon: Gift,
    eyebrow: "Regalos grupales",
    title: "Organiza una vaquita en 2 minutos.",
    subtitle: "Pon una meta, invita a la banda con un link, y todos aportan lo que puedan.",
    hero_img: "https://images.unsplash.com/photo-1513151233558-d860c5398176?w=1200&q=75&fm=jpg",
    features: [
      { title: "Meta y destinatario", desc: "Define para quién es la vaquita y cuánto quieres juntar." },
      { title: "Barra de progreso", desc: "Todos ven cuánto llevan en vivo cada vez que abren el link." },
      { title: "Mensaje por aportación", desc: "Cada quien puede dejar una felicitación o mensaje corto." },
      { title: "Sin cuenta", desc: "Solo pasan el link, aportan y listo." },
    ],
    use_cases: ["Cumpleaños de compa", "Despedida", "Regalo para la maestra", "Baby shower"],
    cta_route: "/registro",
  },
  "reserva-de-citas": {
    icon: CalendarCheck,
    eyebrow: "Reserva de citas",
    title: "Que reserven horario contigo sin escribirte.",
    subtitle: "Elige días, define bloques de tiempo (ej. 15 min) y comparte el link. Todos ven qué está libre.",
    hero_img: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1200&q=75&fm=jpg",
    features: [
      { title: "Días con recurrencia", desc: "Todos los martes, el tercer jueves del mes — con generación automática." },
      { title: "Bloques por duración", desc: "6 pm a 8 pm cada 15 min. La app genera los slots." },
      { title: "Nombres visibles u ocultos", desc: "Público o solo para el organizador — tú decides." },
      { title: "Cambiar y cancelar", desc: "Los invitados manejan su cita desde el mismo link." },
    ],
    use_cases: ["Entrevistas de trabajo", "Asesorías", "Consultas médicas", "Sesiones de terapia"],
    cta_route: "/registro",
  },
};

export const PRODUCT_ROUTES = Object.keys(PRODUCT_PAGES);
